import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    footer: {
      overflow: 'auto',
      padding: componentTheme.footerPadding,
      borderTop: "".concat(componentTheme.footerBorderWidth, " solid ").concat(componentTheme.footerBorderColor),
      fontSize: componentTheme.footerFontSize
    },
    sampleItems: _defineProperty({
      display: 'none'
    }, mp, {
      display: 'inherit'
    }),
    bankItem: _defineProperty({}, mp, {
      display: 'none'
    })
  };
};
export default generateStyle;